import type { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import { cn, DotSeparator } from '@seen/ui'
import type { JSX } from 'react'
import { NoteSourceBadge } from '#src/components/clinical/NoteSourceBadge.tsx'
import { Avatar } from '#src/components/core/Avatar/Avatar.tsx'
import { HoverDate } from '#src/components/core/hover-card/HoverDate.tsx'
import { HoverPractitioner } from '#src/components/core/hover-card/HoverPractitioner.tsx'
import { SanitizedHTML } from '#src/components/core/SanitizedHTML.tsx'

export interface NoteBlockProps {
  message: string
  senderRef?: { reference: string; display?: string }
  sent: string
  comment?: CommentCommunication
  className?: string
}

export function NoteBlock({
  message,
  senderRef,
  sent,
  comment,
  className,
}: NoteBlockProps): JSX.Element {
  return (
    <div className={cn('mt-3 border-border border-t pt-2.5', className)}>
      <SanitizedHTML
        htmlString={message}
        className="text-xs text-foreground-secondary"
      />
      <div className="mt-1 flex items-center gap-1.5 text-[11px] text-muted-foreground">
        <Avatar profile={senderRef} size="icon" className="mt-0.5" />
        <HoverPractitioner practitioner={senderRef} className="truncate" />
        <DotSeparator />
        <HoverDate date={sent} format="relative" />
        {comment && (
          <>
            <DotSeparator />
            <NoteSourceBadge comment={comment} size="sm" />
          </>
        )}
      </div>
    </div>
  )
}
